import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "px-5 pt-6 pb-4 bg-white" };
const _hoisted_2 = { class: "max-w-270 mx-auto" };
const _hoisted_3 = { class: "mb-6 sm:mb-8" };
const _hoisted_4 = { class: "text-2xl sm:text-3xl font-bold text-gray-900" };
const _hoisted_5 = { class: "flex flex-col gap-1 mb-8" };
const _hoisted_6 = { class: "text-sm text-gray-700" };
const _hoisted_7 = {
    key: 0,
    class: "text-sm text-gray-900 font-medium"
};
const _hoisted_8 = {
    key: 1,
    class: "text-sm text-red-600"
};
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-8" };
const _hoisted_10 = { class: "text-base font-semibold text-gray-900 mb-3" };
const _hoisted_11 = { class: "flex flex-col gap-2" };
import { reactive, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { PermissionsService } from "../../infrastructure/adapters/PermissionsService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PermissionsSettings',
    setup(__props) {
        const { t } = useI18n();
        const permissionsService = new PermissionsService();
        const permissionsData = reactive({
            roles: [],
            groups: [],
        });
        const loadError = ref(null);
        const rolesDisplay = computed(() => permissionsData.roles.map((r) => t(`permissions.roles.${r}`)).join(", "));
        async function init() {
            try {
                loadError.value = null;
                const data = await permissionsService.getPermissions();
                Object.assign(permissionsData, data);
            }
            catch (error) {
                loadError.value = error instanceof Error ? error.message : "Failed to load permissions";
            }
        }
        init();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("permissions.title")), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("permissions.description")), 1 /* TEXT */),
                        (!loadError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("permissions.yourRole")) + ": " + _toDisplayString(rolesDisplay.value), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(loadError.value), 1 /* TEXT */))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionsData.groups, (group) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: group.key
                            }, [
                                _createElementVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t(`permissions.groups.${group.key}`)), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_11, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item.key,
                                            class: "flex items-center gap-2"
                                        }, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass([
                                                    'text-[20px] w-5 h-5 flex-shrink-0',
                                                    item.variant === 'warning'
                                                        ? item.enabled
                                                            ? 'ri-error-warning-line text-gray-900'
                                                            : 'ri-error-warning-line text-gray-400'
                                                        : item.enabled
                                                            ? 'ri-checkbox-circle-line text-green-600'
                                                            : 'ri-close-circle-line text-gray-400',
                                                ]),
                                                "aria-hidden": ""
                                            }, null, 2 /* CLASS */),
                                            _createElementVNode("span", {
                                                class: _normalizeClass([
                                                    'text-sm inline-flex items-center gap-1',
                                                    item.enabled
                                                        ? 'text-gray-900'
                                                        : item.variant === 'warning'
                                                            ? 'text-gray-400 line-through'
                                                            : 'text-gray-400',
                                                ])
                                            }, [
                                                _createTextVNode(_toDisplayString(_ctx.$t(`permissions.items.${item.key}`)) + " ", 1 /* TEXT */),
                                                (item.variant === 'warning' || !item.enabled)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass([
                                                            'text-[14px] w-3.5 h-3.5 flex-shrink-0',
                                                            item.enabled
                                                                ? 'ri-question-line text-gray-900'
                                                                : 'ri-question-line text-gray-400',
                                                        ]),
                                                        "aria-hidden": ""
                                                    }, null, 2 /* CLASS */))
                                                    : _createCommentVNode("v-if", true)
                                            ], 2 /* CLASS */)
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ]));
        };
    }
});
